module.exports = __webpack_public_path__ + "img/video.22d30c55.png";